import _ from 'lodash';
import { getMarket } from "./getMarket";

const MARKET = getMarket();

export const __ = (word, type = '') => {
    switch (MARKET) {
        case 'pl':
            word = _.has(global.translations, word) ? global.translations[word] : word;
            break;

        case 'hu':
            word = _.has(global.translations, word) ? global.translations[word] : word;
            break;

        case 'ro':
            word = _.has(global.translations, word) ? global.translations[word] : word;
            break;

        case 'cz':
            word = _.has(global.translations, word) ? global.translations[word] : word;
            break;

        case 'en':
            word = _.has(global.translations, word) ? global.translations[word] : word;
            break;
    }

    switch (type) {
        case 'l':
            return word.toLowerCase();

        case 'u':
            return word.toUpperCase();

        default:
            return word;
    }
};
